import { render, staticRenderFns } from "./addAgent.vue?vue&type=template&id=976d7b7a&scoped=true&"
import script from "./addAgent.vue?vue&type=script&lang=js&"
export * from "./addAgent.vue?vue&type=script&lang=js&"
import style0 from "./addAgent.vue?vue&type=style&index=0&id=976d7b7a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./addAgent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976d7b7a",
  null
  
)

export default component.exports